import { Box, Button } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useAddSection } from './AddSection.hooks'

const AddSection = props => {
	const [{ classes }, { handleAddSection, handleMouseEnter, handleMouseLeave }] = useAddSection(props)

	return (
		<Box className={classes.root}>
			<Button
				className={classes.addSection}
				onClick={handleAddSection}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				<AddIcon />
			</Button>
		</Box>
	)
}

AddSection.propTypes = {
	index: PropTypes.number.isRequired,
	onMouseEnter: PropTypes.func.isRequired,
	onMouseLeave: PropTypes.func.isRequired,
	offset: PropTypes.number,
}

AddSection.defaultProps = {
	offset: 0,
}

export default memo(AddSection)
